import { selectUsers } from 'actions/userPermissionsPage';
import LinkLookup from 'components/LinkLookup';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { getIsSuperAdmin } from 'selectors/auth';
import { useSelector } from 'store';

export type QueryNavbarOption = { label: string; value: string; route: string };

const navOptions = [
  { label: 'Monitored', value: 'monitored', route: 'monitored-users' },
  { label: 'App Users', value: 'll-users', route: 'll-users' },
  { label: 'Additional Profiles', value: 'additional', route: 'additional-users' },
  { label: 'All Users', value: 'all', route: 'all-users' },
];

const UsersNavbar: React.FC = () => {
  const dispatch = useDispatch();
  const route = useRouteMatch<{ userId: string }>();
  const isSuperAdmin = useSelector(getIsSuperAdmin);

  const handleCleanUp = (): void => {
    dispatch(selectUsers([]));
  };

  const renderLinkOption = (option: QueryNavbarOption): JSX.Element => (
    <LinkLookup
      key={option.label}
      type="button"
      className="font-header text-xss leading-4 font-bold text-litlingo-gray-5 border-b-4 border-transparent cursor-pointer pb-1 focus:outline-none"
      routeName={option.route}
      onClick={handleCleanUp}
    >
      {option.label}
    </LinkLookup>
  );

  const renderSelectedOption = (option: QueryNavbarOption): JSX.Element => (
    <div
      key={option.label}
      className="font-header text-xss leading-4 font-bold text-litlingo-gray-6 border-b-4 border-litlingo-orange pb-1"
    >
      {option.label}
    </div>
  );

  return (
    <div className="flex items-center gap-8">
      {navOptions
        .filter((o) => isSuperAdmin || o.value !== 'all')
        .map((option) => {
          if (route.path.split('/').pop() === option.route) {
            return renderSelectedOption(option);
          }
          return renderLinkOption(option);
        })}
    </div>
  );
};

export default UsersNavbar;
